import React, { FunctionComponent } from 'react';
import type { RecruitmentShowApplicationsProps } from './types';
import type { Story } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowApplicationsProps & {
  applications: Story[];
};

export const Presentation: FunctionComponent<Props> = ({
  companyId,
  recruitmentId,
  noimage,
  title,
  isStopped,
  dataCategory,
  dataValue,
  applications,
  isPreview,
}) => {
  if (applications.length === 0) return null

  return (
    <div className="recruitment__show__content recruitment__show__company" id="company-stories-section">
      <h2 className="mainTitle">
        {title}
        <a
          className="link gtm-button-view-count"
          href={`/companies/${companyId}/stories`}
          {...(!isPreview && {
            'data-event-name': 'button on screen',
            'data-event': 'click',
            'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
            'data-value': dataValue.selfStoriesMore
          })}
        >
          もっと見る
        </a>
      </h2>

      <div className="recruitment__show__applications__slider js-recruitment-applications">
        {applications.map(application => (
          <a
            key={application.id}
            href={`/companies/${companyId}/story_show?post_id=${application.id}`}
            {...(!isPreview && {
              'data-event-name': 'story on screen',
              'data-event': 'click',
              'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
              'data-value': dataValue.selfStories,
              'data-recruitmentid': recruitmentId,
              'data-companyid': companyId
            })}
            target="_blank"
            className="box gtm-story-view-count"
            rel="noopener noreferrer"
          >
            <img src={application.image?.url || noimage} alt={`${application.title}の画像`} />
            <p className="title">
              {application.hashTags.map(hashtag => (
                <React.Fragment key={hashtag.name}>
                  {hashtag.name}&nbsp;
                </React.Fragment>
              ))}
            </p>
            <p className="body">{application.title}</p>
          </a>
        ))}
      </div>
    </div>
  );
};
